import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import { BrowserRouter as Router } from "react-router-dom";

import App from "./App";
import { StateProvider } from "./context/StateProvider";
import reducer from "./context/reducer";
import { INITIAL_STATE } from "./context/iniState";

ReactDOM.render(
  <Router>
    <StateProvider initialState={INITIAL_STATE} reducer={reducer}>
      <App />
    </StateProvider>
  </Router>,
  document.getElementById("root")
);
